import { useTranslation } from "react-i18next";

const EnabledOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "enabled",
      title: t("options.enable.enabled"),
      value: "1",
    },
    {
      key: "disabled",
      title: t("options.enable.disabled"),
      value: "0",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default EnabledOptions;
